import productList from './list'
import productUtils from '@/core/productUtils'
const state = {
  ...productList.state,
}
const getters = {
  ...productList.getters,
  // 用于展示的列表数据，增加额定值：当单速单搜风量的时候，会出现部分属性值是范围的情况，这种时候选中需要取额定值作为运行值
  tableData: (state) => {
    const list = state.products
    const samplesMapping = state.samplesMapping
    const data = []
    list.forEach((item) => {
      const productProps = item.productPropertyValues || []
      const speedControl = item.speedControl || 'SINGLE_SPEED'
      const productPropsObj = productUtils.handleProductPropertiesData({
        productsData: productProps,
        category: 'fan',
        speed: speedControl,
        allProps: state.allProperties
      })
      const sampleMap = samplesMapping.find((s) => s.productId === item.id) || {}
      const obj = {
        id: item.id,
        sampleId: sampleMap.sampleId,
        brandCode: item.brandCode,
        brandName: item.brandName,
        model: item.model,
        name: item.name,
        imageUrl: item.imageUrl,
        productSeriesId: item.productSeriesId,
        productSeriesName: item.productSeriesName,
        powerConsumptionPerAirVolume: item.powerConsumptionPerAirVolume,
        speedControl,
        ...productPropsObj,
      }
      data.push(obj)
    })
    return data
  }
}
const mutations = {
  ...productList.mutations,
}
const actions = {
  ...productList.actions,
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
